/*
 * HomePage Messages
 *
 * This contains all the text for the HomePage component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    defaultMessage: 'I Like',
    id: 'app.home.header'
  },
  start: {
    defaultMessage: 'Start',
    id: 'app.home.start'
  },
  text: {
    defaultMessage:
      'Travel with Sporti to space and discover your favorite sport planets.',
    id: 'app.home.text'
  },
  title: {
    defaultMessage: 'SportKompas',
    id: 'app.home.title'
  },
  logos: {
    defaultMessage: 'A product by: NYSI, Sportamundi, & Ghent University',
    id: 'app.home.logos'
  }
});



// WEBPACK FOOTER //
// ./src/containers/home/messages.js